// allow cross origin download:
// https://stackoverflow.com/questions/49474775/chrome-65-blocks-cross-origin-a-download-client-side-workaround-to-force-down#answer-49500465
function forceDownload(blob, filename) {
  var a = document.createElement('a');
  a.download = filename;
  a.href = blob;
  document.body.appendChild(a);
  a.click();
  a.remove();
}


function downloadResource(url, filename) {
  if (!filename) filename = url.split('\\').pop().split('/').pop().split('?').shift();
  fetch(url, {
      headers: new Headers({
        'Origin': location.origin
      }),
      mode: 'cors'
    })
    .then(response => response.blob())
    .then(blob => {
      let blobUrl = window.URL.createObjectURL(blob);
      forceDownload(blobUrl, filename);
    })
    .catch(e => console.error(e));
}




  function forceDownloadClick(e) {
    if(e) {
      e.preventDefault();
    }
    e.target.closest('a').classList.add('working');
     
    downloadResource(e.target.closest('a').getAttribute('href'));
  }

  const allDownloadButtons = document.querySelectorAll('.force-download');
  if (allDownloadButtons.length > 0) {
    for (i = 0; i < allDownloadButtons.length; i++) {
      allDownloadButtons[i].onclick = forceDownloadClick;
    }
  }
